export default "__VITE_ASSET__fce956c4__"